import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SaDeliveryNoteService extends ApiService {

    index(params: any = {}) {
        return super.get(`/sa-delivery-notes`, params);
    }

    generate(body: any) {
        return super.post(`/sa-delivery-notes/generate`, body);
    }

    show(deliveryNoteId: number): Observable<any> {
        return super.get(`/sa-delivery-notes/${deliveryNoteId}`);
    }

    regenerate(id: number) {
        return super.post(`/sa-delivery-notes/${id}/regenerate`, {});
    }

    regenerateFromPickings(id: number) {
        return super.post(`/sa-delivery-notes/${id}/regenerate-from-pickings`, {});
    }

    sendToIntranet(id: number) {
        return super.post(`/sa-delivery-notes/${id}/send-to-intranet`);
    }

    pdf(id: number) {
        return super.getFile(`/sa-delivery-notes/${id}/pdf`);
    }

    lines(deliveryNoteId: number): Observable<any> {
        return super.get(`/sa-delivery-notes/${deliveryNoteId}/lines`);
    }

    annexPdf(id: number) {
        return super.getFile(`/sa-delivery-notes/${id}/annex-pdf`);
    }

    billed(deliveryNoteId: number) {
        return super.post(`/sa-delivery-notes/${deliveryNoteId}/billed`);
    }

    pending(deliveryNoteId: number, pending: boolean) {
        return super.post(`/sa-delivery-notes/${deliveryNoteId}/pending`, { pending });
    }

    generateInvoiceDrafts(body: any) {
        return super.post(`/sa-delivery-notes/generate-invoice-drafts`, body);
    }

    printPreview(body: any) {
        return super.post(`/sa-delivery-notes/print-preview`, body);
    }

    print(body: any) {
        return super.post(`/sa-delivery-notes/print`, body);
    }

    transporterCall(deliveryNoteId: number, body: { qty_box: number; qty_pallet?: number; printer_id: number }) {
        return super.post(`/sa-delivery-notes/${deliveryNoteId}/transporter-call`, body);
    }

    updateDeliveryDates(body: any) {
        return super.put(`/sa-delivery-notes/delivery-dates`, body);
    }

    updateDeliveryTours(body: any) {
        return super.put(`/sa-delivery-notes/delivery-tours`, body);
    }

    updateDeliveryZones(body: any) {
        return super.put(`/sa-delivery-notes/delivery-zones`, body);
    }
}
